import SnipeAssetUserAssets from '@/components/snipeasset/user/assets/SnipeAssetUserAssets.vue'
import AxaptaUserHolidayList from '@/components/axapta/user/holidaylist/AxaptaUserHolidayList.vue'
import UserModelPermissions from '@/components/user/user-model-permissions/UserModelPermissions.vue';

export default {
  name: 'UserListExpand',
  props: {
    data: Object
  },
  components: {
    AxaptaUserHolidayList,
    SnipeAssetUserAssets,
    UserModelPermissions
  },
  computed: {
    canSeeModelPermissions () {
      return this.ApiRequest.userHasPermission('view-model-permissions');
    }
  },
  methods: {
    getAdGroupClass (group) {
      let res = '';
      if (parseInt(this.data.isDisabled)) {
        res += ' rounded-block-disabled';
      } else if (group.request) {
        res += ' rounded-block-' + group.request;
      }
      return res;
    }
  }
}
